import { render, staticRenderFns } from "./AssignTask.vue?vue&type=template&id=097c4e84"
import script from "./AssignTask.vue?vue&type=script&lang=js"
export * from "./AssignTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports